import styled from "styled-components";
import { colors } from "../../theme/color";
import fipayFonts from "../../theme/index";
import { ReactNode } from "react";

interface ButtonProps extends React.PropsWithChildren {
  id?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  onClick?: () => void;
  padding?: string;
  title?: string | ReactNode;
  navyBlue?: boolean;
  green?: boolean;
  transparent?: boolean;
  opaque?: boolean;
  border?: string;
  className?: string;
  width?: string;
  cancel?: boolean;
  whiteBg?: boolean;
  grey?: boolean;
}
const Button: React.FC<ButtonProps> = ({
  id,
  type,
  disabled,
  onClick,
  padding,
  title,
  green,
  navyBlue,
  transparent,
  cancel,
  opaque,
  children,
  border,
  width,
  className,
  whiteBg,
  grey,
}) => {
  return (
    <StyledButton
      id={id}
      type={type}
      disabled={disabled}
      onClick={onClick}
      $padding={padding || "0"}
      $green={green}
      $navyBlue={navyBlue}
      $cancel={cancel}
      $transparent={transparent}
      $opaque={opaque}
      $border={border}
      $width={width}
      className={className}
      $whiteBg={whiteBg}
      $grey={grey}
    >
      {children || title}
    </StyledButton>
  );
};

export default Button;

/**
 * StyledButton - Styled button element using styled-components.
 *
 */

export const StyledButton = styled.button<{
  $navyBlue?: boolean;
  $green?: boolean;
  $transparent?: boolean;
  $padding: string;
  $opaque?: boolean;
  $border?: string;
  $width?: string;
  $cancel?: boolean;
  $whiteBg?: boolean;
  $grey?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ disabled, ...props }) =>
    disabled || props.$grey
      ? colors.ButtonBackgroundColors.primaryDisabledButton
      : props.$navyBlue
        ? colors.NAVYBLUE
        : props.$green
          ? colors.secondary.islamicGreen
          : props.$cancel
            ? "transparent"
            : props.$whiteBg
              ? colors.White
              : "transparent"};
  padding: ${({ $padding }) => $padding};
  width: ${({ $width }) => $width};
  border-radius: ${({ $border }) => $border || "30px"};
  border: ${({ disabled, ...props }) =>
    disabled || props.$whiteBg
      ? "none"
      : props.$transparent || props.$navyBlue
        ? `1px solid ${colors.NAVYBLUE}`
        : props.$green
          ? `1px solid ${colors.secondary.islamicGreen}`
          : props.$cancel
            ? `1px solid ${colors.neutral.silverFoil}`
            : ""};
  color: ${({ ...props }) =>
    props.$transparent
      ? colors.NAVYBLUE
      : props.$cancel
        ? colors.neutral.silverFoil
        : props.$whiteBg
          ? colors.secondary.islamicGreen
          : colors.White};

  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  font-family: "GT Walsheim Pro";
  font-weight: ${({ ...props }) =>
    props.$whiteBg
      ? fipayFonts.fipayFonts.fontWeight.medium
      : fipayFonts.fipayFonts.fontWeight.bold1};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body3};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  white-space: nowrap;
  transition: background-color 0.3s ease;
  cursor: pointer;
  opacity: ${({ $opaque }) => ($opaque ? 0.5 : 1)};
  &:hover {
    background-color: ${({ ...props }) =>
      props.$green
        ? colors.ButtonBackgroundColors.secondarySelectedButton
        : ""};
    border: ${({ ...props }) =>
      props.$cancel
        ? `1px solid ${colors.neutral.silverFoil}`
        : props.$transparent || props.$navyBlue
          ? `1px solid ${colors.NAVYBLUE}`
          : "none"};
  }
  @media only screen and (max-width: 767px) {
    /* padding: 10px 20px; */
    flex-wrap: wrap;
    white-space: normal;
    align-items: center;
    font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  }
`;
